// extracted by mini-css-extract-plugin
module.exports = {"container":"Styles_container__1HOu6","list":"Styles_list__623to"};